module.exports = {
        srcSet: __webpack_public_path__ + "static/media/document-400.3fedc71b.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/document-400.3fedc71b.webp",width: 400,height: 399}],
        src: __webpack_public_path__ + "static/media/document-400.3fedc71b.webp",
        toString: function(){return __webpack_public_path__ + "static/media/document-400.3fedc71b.webp"},
        
        width: 400,
        height: 399
      }